import React from 'react'
import LoadAsset from '../pages/DesignAssets/LoadAsset'
import LoadCB from '../pages/DesignAssets/LoadCB';

const LoadConfigDetailsModal = (props) => {
   const loadData = {...props};
  const isCbRequired = loadData?.CBLoadList?.[loadData?.selectedValues?.selectedLoad]?.uiData?.cbRequired;
  const cbName = loadData?.configData?.cbConfigData?.name || "";
  const isCbValidName = isCbRequired && (cbName === "" || !/^[a-zA-Z0-9-_& ]+$/.test(cbName));
  return (
    <se-dialog
    id="dialog-complex"
    size="large"
    open={loadData?.isOpenLoadConfig}
    can-backdrop="false"
    style = {{visibility:`${loadData?.assetInfo?.assetSelected?"hidden":"visible"}`}}
  >
    <se-dialog-header> Configure Load</se-dialog-header>

    <se-dialog-content className="se-dialog-content">
      { loadData &&  <LoadAsset loadData ={loadData} isCbValidName={isCbValidName} />}
      { loadData && loadData?.CBLoadList[loadData?.selectedValues?.selectedLoad]?.uiData?.cbRequired &&  <LoadCB loadData ={loadData} />}
    </se-dialog-content>
    <se-dialog-footer>
      <se-button disabled = {loadData?.configData?.configData?.name ==="" || ! /^[a-zA-Z0-9 ]+$/.test(loadData?.configData?.configData?.name)   || isCbValidName } onClick={()=>loadData?.setIsOpenLoadConfig(false)}>Close</se-button>
    </se-dialog-footer>
  </se-dialog>
  )
}

export default LoadConfigDetailsModal